/* eslint-disable import/order */
import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';
import { nextBestTaskFeatureResource } from '@jira/router-resources__next-best-task/src/nextBestTaskFeatureResource.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
// eslint-disable-next-line jira/restricted/fedramp-isolated-cloud
import { isFedRamp } from '@atlassian/atl-context';
import { fg } from '@atlassian/jira-feature-gating';
import type { RouteResource } from '@atlassian/react-resource-router';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const conditionalBoardNBTOptInResource: RouteResource<any> = resourceWithCondition(
	() => (fg('aem_rr_sw_board') ? isFeatureEnabled('jira', 'jira-next-best-task') : !isFedRamp()),
	nextBestTaskFeatureResource,
);
